import { render, staticRenderFns } from "./BaseErrorModal.vue?vue&type=template&id=6aadbb20&scoped=true&"
import script from "./BaseErrorModal.vue?vue&type=script&lang=js&"
export * from "./BaseErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseErrorModal.vue?vue&type=style&index=0&id=6aadbb20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadbb20",
  null
  
)

export default component.exports